import { useEffect } from 'react';
import { Navigate } from '@tanstack/react-router';
import { useEditorSearch } from 'app/router/params';
import { dispatchMessage, EventType } from 'shared/feedback/toasts';
import { i18n } from 'shared/i18n';

export const SectionAccessDenied = ({ documentId }: { documentId: string }) => {
  const { goToCommentId } = useEditorSearch();

  useEffect(() => {
    if (!goToCommentId) return;
    dispatchMessage(EventType.ADD_MESSAGE, { type: 'error', text: i18n('notifications:no-section-access'), removeTime: 6000 });
  }, [goToCommentId]);

  return <Navigate to="/documents/$documentId" params={{ documentId }} replace />;
};
